import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import {
  IPartProTradeSettings,
  IUpdatePartProTradeSettings,
} from "../models/partPro/IPartProTradeSettings";

const SETTINGS_KEY = ["partpro", "trade", "settings"];

export default function usePartProTrade(enabled = true) {
  const { get, put } = useApiHelper();
  const queryClient = useQueryClient();

  const settings = useQuery({
    queryKey: SETTINGS_KEY,
    queryFn: () => get<DefaultResponseWithData<IPartProTradeSettings>>("/partpro/trade/settings"),
    enabled,
    // A 400 here means "not enabled" or "not connected" - retrying will not change that
    retry: false,
  });

  const updateSettings = useMutation({
    mutationFn: (body: IUpdatePartProTradeSettings) =>
      put<IUpdatePartProTradeSettings, DefaultResponseWithData<IPartProTradeSettings>>(
        "/partpro/trade/settings",
        body
      ),
    onSuccess: (res) => {
      // PartPro is the source of truth - seed the cache with what it returned
      queryClient.setQueryData(SETTINGS_KEY, res);
      queryClient.invalidateQueries({ queryKey: SETTINGS_KEY });
    },
  });

  return { settings, updateSettings };
}
